<template>
  <div
    :class="['cf', { 'cf--open': isFilterDrawerOpen }]"
    :aria-modal="isFilterDrawerOpen ? 'true' : undefined"
    :role="isFilterDrawerOpen ? 'dialog' : undefined"
    :aria-hidden="!isFilterDrawerOpen"
  >
    <template v-for="facet in algoliaFacetData" :key="facet.filterKey">
      <CollectionPriceSlider
        v-if="facet.filterKey === 'price'"
        :price-range="priceRange"
        :applied-price-range="activePriceRange"
        @price-change="onPriceChange"
      />
      <CollectionFilterModule
        v-else
        :filter-type="facet.filterKey"
        :filter-options="facet.values"
        :applied-filters="appliedFilters[facet.filterKey]"
        @input-change="inputChange"
      />
    </template>
    <div v-if="appliedFiltersCount > 0 && isFilterDrawerOpen" class="cf__bottom">
      <button @click="emit('clearFilter')" class="cf__bottom-clear" aria-label="Clear all filters">
        Clear Filters
      </button>
      <button
        @click="emit('toggleFilterDrawer')"
        class="btn btn--secondary btn--medium cf__bottom-apply"
        aria-label="Apply filters"
      >
        Apply
      </button>
    </div>
  </div>
</template>

<script setup>
  import CollectionFilterModule from './collection-filter-module.vue';
  import CollectionPriceSlider from './collection-price-slider.vue';

  const props = defineProps({
    isFilterDrawerOpen: {
      type: Boolean,
      default: false,
    },

    algoliaFacetData: {
      type: Array,
      default: () => [],
    },

    appliedFilters: {
      type: Object,
      required: true,
    },

    appliedFiltersCount: {
      type: Number,
      required: true,
    },

    priceRange: {
      type: Object,
      default: () => ({ min: 0, max: 1000 }),
    },

    activePriceRange: {
      type: Array,
      default: () => [],
    },
  });

  const emit = defineEmits(['updateAppliedFilters', 'toggleFilterDrawer', 'clearFilter', 'priceChange']);

  const inputChange = (filterKey, options) => {
    emit('updateAppliedFilters', filterKey, options);
  };

  const onPriceChange = (range) => {
    emit('priceChange', range);
  };
</script>
